// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import CheckIn from "./check-in.js"
import SchoolClass from "./school-class.js"

const modelClassData = {
  "attributes": {
    "has_state_lobby": {
      "column": null,
      "name": "has_state_lobby",
      "selected_by_default": null,
      "translated": null
    },
    "has_state_cancelled": {
      "column": null,
      "name": "has_state_cancelled",
      "selected_by_default": null,
      "translated": null
    },
    "has_state_closed": {
      "column": null,
      "name": "has_state_closed",
      "selected_by_default": null,
      "translated": null
    },
    "has_state_expired": {
      "column": null,
      "name": "has_state_expired",
      "selected_by_default": null,
      "translated": null
    },
    "state_may_cancel": {
      "column": null,
      "name": "state_may_cancel",
      "selected_by_default": false,
      "translated": null
    },
    "state_may_close": {
      "column": null,
      "name": "state_may_close",
      "selected_by_default": false,
      "translated": null
    },
    "state_may_expire": {
      "column": null,
      "name": "state_may_expire",
      "selected_by_default": false,
      "translated": null
    },
    "cache_average_mood": {
      "column": {
        "default": null,
        "name": "cache_average_mood",
        "null": true,
        "type": "decimal"
      },
      "name": "cache_average_mood",
      "selected_by_default": null,
      "translated": null
    },
    "check_in_id": {
      "column": {
        "default": null,
        "name": "check_in_id",
        "null": false,
        "type": null
      },
      "name": "check_in_id",
      "selected_by_default": null,
      "translated": null
    },
    "code": {
      "column": {
        "default": null,
        "name": "code",
        "null": false,
        "type": "string"
      },
      "name": "code",
      "selected_by_default": null,
      "translated": null
    },
    "completed_team_surveys_count": {
      "column": {
        "default": "0",
        "name": "completed_team_surveys_count",
        "null": false,
        "type": "integer"
      },
      "name": "completed_team_surveys_count",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "entry_date": {
      "column": {
        "default": null,
        "name": "entry_date",
        "null": false,
        "type": "datetime"
      },
      "name": "entry_date",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "school_class_id": {
      "column": {
        "default": null,
        "name": "school_class_id",
        "null": false,
        "type": null
      },
      "name": "school_class_id",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "lobby",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "user_lobby": {
      "column": {
        "default": "0",
        "name": "user_lobby",
        "null": false,
        "type": "boolean"
      },
      "name": "user_lobby",
      "selected_by_default": null,
      "translated": null
    },
    "qrcode_url_path": {
      "column": null,
      "name": "qrcode_url_path",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "SchoolClassCheckIn",
  "collectionKey": "school_class_check_ins",
  "collectionName": "school_class_check_ins",
  "i18nKey": "school_class_check_in",
  "camelizedLower": "schoolClassCheckIn",
  "name": "SchoolClassCheckIn",
  "nameDasherized": "school-class-check-in",
  "pluralName": "school_class_check_ins",
  "ransackable_associations": [
    {
      "className": "SchoolClassCheckIn::Audit",
      "collectionName": "school_class_check_in_audits",
      "foreignKey": "school_class_check_in_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "SchoolClassCheckInAudit",
      "through": null
    },
    {
      "className": "CheckIn",
      "collectionName": "check_ins",
      "foreignKey": "check_in_id",
      "name": "check_in",
      "macro": "belongs_to",
      "resource_name": "CheckIn",
      "through": null
    },
    {
      "className": "SchoolClassCheckIn::Audit",
      "collectionName": "school_class_check_in_audits",
      "foreignKey": "school_class_check_in_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "SchoolClassCheckInAudit",
      "through": null
    },
    {
      "className": "SchoolClassCheckInEvent",
      "collectionName": "school_class_check_in_events",
      "foreignKey": "school_class_check_in_id",
      "name": "events",
      "macro": "has_many",
      "resource_name": "SchoolClassCheckInEvent",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "belongs_to",
      "resource_name": "SchoolClass",
      "through": null
    },
    {
      "className": "SchoolClassCourse",
      "collectionName": "school_class_courses",
      "foreignKey": "school_class_check_in_id",
      "name": "school_class_course",
      "macro": "has_one",
      "resource_name": "SchoolClassCourse",
      "through": null
    },
    {
      "className": "SchoolClassCheckInScoreFactorCache",
      "collectionName": null,
      "foreignKey": "school_class_check_in_id",
      "name": "score_factor_caches",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "has_one",
      "resource_name": "Survey",
      "through": "check_in"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "school_class_check_in_id",
      "name": "team_surveys",
      "macro": "has_many",
      "resource_name": "TeamSurvey",
      "through": null
    },
    {
      "className": "ScoreFactor",
      "collectionName": "score_factors",
      "foreignKey": "top_negative_score_factor_id",
      "name": "top_negative_score_factor",
      "macro": "belongs_to",
      "resource_name": "ScoreFactor",
      "through": null
    },
    {
      "className": "ScoreFactor",
      "collectionName": "score_factors",
      "foreignKey": "top_positive_score_factor_id",
      "name": "top_positive_score_factor",
      "macro": "belongs_to",
      "resource_name": "ScoreFactor",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "school_class_check_in_id",
      "name": "users",
      "macro": "has_many",
      "resource_name": "User",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "cache_average_mood",
      "column": {
        "default": null,
        "name": "cache_average_mood",
        "null": true,
        "type": "decimal"
      }
    },
    {
      "name": "check_in_id",
      "column": {
        "default": null,
        "name": "check_in_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "code",
      "column": {
        "default": null,
        "name": "code",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "completed_team_surveys_count",
      "column": {
        "default": "0",
        "name": "completed_team_surveys_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "entry_date",
      "column": {
        "default": null,
        "name": "entry_date",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "school_class_id",
      "column": {
        "default": null,
        "name": "school_class_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "state",
      "column": {
        "default": "lobby",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "top_negative_score_factor_id",
      "column": {
        "default": null,
        "name": "top_negative_score_factor_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "top_positive_score_factor_id",
      "column": {
        "default": null,
        "name": "top_positive_score_factor_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "unicorn_effect_sequence",
      "column": {
        "default": null,
        "name": "unicorn_effect_sequence",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "user_id",
      "column": {
        "default": null,
        "name": "user_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "user_lobby",
      "column": {
        "default": "0",
        "name": "user_lobby",
        "null": false,
        "type": "boolean"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "school_class_or_groups_eq_any"
    }
  ],
  "relationships": [
    {
      "className": "CheckIn",
      "collectionName": "check_ins",
      "foreignKey": "check_in_id",
      "name": "check_in",
      "macro": "belongs_to",
      "resource_name": "CheckIn",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "belongs_to",
      "resource_name": "SchoolClass",
      "through": null
    }
  ],
  "paramKey": "school_class_check_in",
  "primaryKey": "id"
}

/** Frontend model for SchoolClassCheckIn. */
export default class SchoolClassCheckIn extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  hasStateLobby() {
    return this.readAttributeUnderscore("has_state_lobby")
  }

  /** @returns {boolean} */
  hasHasStateLobby() {
    const value = this.hasStateLobby()

    return this._isPresent(value)
  }

  /** @returns {any} */
  hasStateCancelled() {
    return this.readAttributeUnderscore("has_state_cancelled")
  }

  /** @returns {boolean} */
  hasHasStateCancelled() {
    const value = this.hasStateCancelled()

    return this._isPresent(value)
  }

  /** @returns {any} */
  hasStateClosed() {
    return this.readAttributeUnderscore("has_state_closed")
  }

  /** @returns {boolean} */
  hasHasStateClosed() {
    const value = this.hasStateClosed()

    return this._isPresent(value)
  }

  /** @returns {any} */
  hasStateExpired() {
    return this.readAttributeUnderscore("has_state_expired")
  }

  /** @returns {boolean} */
  hasHasStateExpired() {
    const value = this.hasStateExpired()

    return this._isPresent(value)
  }

  /** @returns {any} */
  stateMayCancel() {
    return this.readAttributeUnderscore("state_may_cancel")
  }

  /** @returns {boolean} */
  hasStateMayCancel() {
    const value = this.stateMayCancel()

    return this._isPresent(value)
  }

  /** @returns {any} */
  stateMayClose() {
    return this.readAttributeUnderscore("state_may_close")
  }

  /** @returns {boolean} */
  hasStateMayClose() {
    const value = this.stateMayClose()

    return this._isPresent(value)
  }

  /** @returns {any} */
  stateMayExpire() {
    return this.readAttributeUnderscore("state_may_expire")
  }

  /** @returns {boolean} */
  hasStateMayExpire() {
    const value = this.stateMayExpire()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  cacheAverageMood() {
    return this.readAttributeUnderscore("cache_average_mood")
  }

  /** @returns {boolean} */
  hasCacheAverageMood() {
    const value = this.cacheAverageMood()

    return this._isPresent(value)
  }

  /** @returns {any} */
  checkInId() {
    return this.readAttributeUnderscore("check_in_id")
  }

  /** @returns {boolean} */
  hasCheckInId() {
    const value = this.checkInId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  code() {
    return this.readAttributeUnderscore("code")
  }

  /** @returns {boolean} */
  hasCode() {
    const value = this.code()

    return this._isPresent(value)
  }

  /** @returns {number} */
  completedTeamSurveysCount() {
    return this.readAttributeUnderscore("completed_team_surveys_count")
  }

  /** @returns {boolean} */
  hasCompletedTeamSurveysCount() {
    const value = this.completedTeamSurveysCount()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  entryDate() {
    return this.readAttributeUnderscore("entry_date")
  }

  /** @returns {boolean} */
  hasEntryDate() {
    const value = this.entryDate()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  schoolClassId() {
    return this.readAttributeUnderscore("school_class_id")
  }

  /** @returns {boolean} */
  hasSchoolClassId() {
    const value = this.schoolClassId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  userLobby() {
    return this.readAttributeUnderscore("user_lobby")
  }

  /** @returns {boolean} */
  hasUserLobby() {
    const value = this.userLobby()

    return this._isPresent(value)
  }

  /** @returns {any} */
  qrcodeUrlPath() {
    return this.readAttributeUnderscore("qrcode_url_path")
  }

  /** @returns {boolean} */
  hasQrcodeUrlPath() {
    const value = this.qrcodeUrlPath()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static codeLookup(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "code_lookup",
        collectionName: "school_class_check_ins",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static countChart(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "count_chart",
        collectionName: "school_class_check_ins",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  close(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "close",
        primaryKey: this.primaryKey(),
        collectionName: "school_class_check_ins",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./check-in.js").default | null} */
  checkIn() {
    return this._readBelongsToReflection({modelClass: CheckIn, reflectionName: "check_in"})
  }

  /** @returns {Promise<import("./check-in.js").default | null>} */
  loadCheckIn() {
    if (!("checkInId" in this)) throw new Error("Foreign key method wasn't defined: checkInId")

    const id = this.checkInId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "check_in",
        model: this,
        modelClass: CheckIn
      },
      {ransack}
    )
  }

  /** @returns {import("./school-class.js").default | null} */
  schoolClass() {
    return this._readBelongsToReflection({modelClass: SchoolClass, reflectionName: "school_class"})
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  loadSchoolClass() {
    if (!("schoolClassId" in this)) throw new Error("Foreign key method wasn't defined: schoolClassId")

    const id = this.schoolClassId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "school_class",
        model: this,
        modelClass: SchoolClass
      },
      {ransack}
    )
  }
}
